import { preventCancelableDefault } from '@polestar/component-warehouse-react/helpers/event';
import { supportsHover } from '@polestar/component-warehouse-react/helpers/supports';
import { useCallback, useEffect, useState, } from 'react';
export const useButton = ({ onMouseDown, onMouseUp, onTouchStart, onTouchEnd, onTouchMove, onMouseLeave, onMouseEnter, onDragStart, onKeyDown, onKeyUp, onFocus, onBlur, }) => {
    const [active, setActive] = useState(false);
    const [hover, setHover] = useState(false);
    useEffect(() => {
        let timeout;
        if (active) {
            timeout = setTimeout(() => {
                setActive(false);
            }, 1000);
        }
        return () => {
            clearTimeout(timeout);
        };
    }, [active]);
    const handleMouseDown = useCallback((e) => {
        var _a;
        if ((e === null || e === void 0 ? void 0 : e.button) === 0 || ((_a = e === null || e === void 0 ? void 0 : e.touches) === null || _a === void 0 ? void 0 : _a.length) === 1) {
            setActive(true);
        }
        onMouseDown === null || onMouseDown === void 0 ? void 0 : onMouseDown(e);
    }, [onMouseDown]);
    const handleMouseUp = useCallback((e) => {
        setActive(false);
        onMouseUp === null || onMouseUp === void 0 ? void 0 : onMouseUp(e);
    }, [onMouseUp]);
    const handleTouchStart = useCallback((e) => {
        var _a;
        if ((e === null || e === void 0 ? void 0 : e.button) === 0 || ((_a = e === null || e === void 0 ? void 0 : e.touches) === null || _a === void 0 ? void 0 : _a.length) === 1) {
            setActive(true);
        }
        onTouchStart === null || onTouchStart === void 0 ? void 0 : onTouchStart(e);
    }, [onTouchStart]);
    const handleTouchEnd = useCallback((e) => {
        setActive(false);
        onTouchEnd === null || onTouchEnd === void 0 ? void 0 : onTouchEnd(e);
    }, [onTouchEnd]);
    const handleTouchMove = useCallback((e) => {
        setActive(false);
        onTouchMove === null || onTouchMove === void 0 ? void 0 : onTouchMove(e);
    }, [onTouchMove]);
    const handleMouseLeave = useCallback((e) => {
        setActive(false);
        setHover(false);
        onMouseLeave === null || onMouseLeave === void 0 ? void 0 : onMouseLeave(e);
    }, [onMouseLeave]);
    const handleMouseEnter = useCallback((e) => {
        setHover(true);
        onMouseEnter === null || onMouseEnter === void 0 ? void 0 : onMouseEnter(e);
    }, [onMouseEnter]);
    const handleFocus = useCallback((e) => {
        setHover(true);
        onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
    }, [onFocus]);
    const handleBlur = useCallback((e) => {
        setHover(false);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
    }, [onBlur]);
    const handleDragStart = useCallback((e) => {
        preventCancelableDefault(e);
        setActive(false);
        onDragStart === null || onDragStart === void 0 ? void 0 : onDragStart(e);
    }, [onDragStart]);
    const handleKeyDown = useCallback((e) => {
        const isAnchor = e.currentTarget.tagName === 'A';
        if (
        // <a> activates on enter only
        (isAnchor && e.key === 'Enter') ||
            // <button> activates on enter and space
            (!isAnchor && (e.key === ' ' || e.key === 'Enter'))) {
            setActive(true);
        }
        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
    }, [onKeyDown]);
    const handleKeyUp = useCallback((e) => {
        setActive(false);
        onKeyUp === null || onKeyUp === void 0 ? void 0 : onKeyUp(e);
    }, [onKeyUp]);
    return {
        active,
        hover: supportsHover ? hover : false,
        onMouseDown: handleMouseDown,
        onMouseUp: handleMouseUp,
        onTouchStart: handleTouchStart,
        onTouchEnd: handleTouchEnd,
        onMouseLeave: handleMouseLeave,
        onMouseEnter: handleMouseEnter,
        onDragStart: handleDragStart,
        onTouchMove: handleTouchMove,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onFocus: handleFocus,
        onBlur: handleBlur,
    };
};
